module.exports = __webpack_public_path__ + "static/media/multietapaSB.9bf2e5a3.jpg";